// extracted by mini-css-extract-plugin
module.exports = {"action":"AccountPane_action__2CKjd","actionButton":"AccountPane_actionButton__247J7","wrapper":"AccountPane_wrapper__1CW68"};